import React, { useState, useContext, useRef, useEffect } from "react";
import style from "./InternAiStyle";
import { FiTrendingUp, FiMessageCircle, FiZap, FiSend } from "react-icons/fi";
import { AuthContext } from "../../Context/AuthContext";
import { LoadingContext } from "../../Context/LoadingContext";
import { askInternAi } from "../../Services/dbservice";

export default function InternAi() {
  const [prompt, setPrompt] = useState("");
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { credentials } = useContext(AuthContext);
  const { startLoading, stopLoading } = useContext(LoadingContext);
  const chatHistoryRef = useRef(null);

  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSend = async (currentPrompt) => {
    const userPrompt = currentPrompt || prompt;
    if (!userPrompt.trim()) return;

    const userMessage = { sender: "user", text: userPrompt };
    setMessages((prev) => [...prev, userMessage]);
    setPrompt("");
    setIsLoading(true);
    startLoading();

    try {
      const response = await askInternAi(userPrompt, credentials.accessToken);
      const aiMessage = { sender: "ai", text: response.answer };
      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      const errorMessage = {
        sender: "ai",
        text: "Ocorreu um erro ao obter a resposta. Tente novamente.",
      };
      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setIsLoading(false);
      stopLoading();
    }
  };

  const suggestionCards = [
    {
      icon: <FiTrendingUp size={24} />,
      text: "Como estão indo minhas vendas?",
    },
    {
      icon: <FiMessageCircle size={24} />,
      text: "Como estão as conversas com os clientes?",
    },
    { icon: <FiZap size={24} />, text: "Como posso melhorar meus resultados?" },
  ];

  return (
    <div style={style.container}>
      <div style={style.chatWrapper}>
        <div style={style.chatHistory} ref={chatHistoryRef}>
          {messages.length === 0 ? (
            <div style={style.welcomeSection}>
              <div style={style.logo}>✨</div>
              <h1 style={style.title}>Olá! Como posso te ajudar hoje?</h1>
              <div style={style.suggestionsGrid}>
                {suggestionCards.map((card, index) => (
                  <div
                    key={index}
                    style={style.suggestionCard}
                    onClick={() => handleSend(card.text)}
                  >
                    <p style={style.cardText}>{card.text}</p>
                    <div style={style.cardIcon}>{card.icon}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            messages.map((msg, index) => (
              <div
                key={index}
                style={
                  msg.sender === "user" ? style.userMessage : style.aiMessage
                }
              >
                <div style={style.messageContent}>
                  <span style={style.senderName}>
                    {msg.sender === "user" ? "Você" : "IA Interna"}
                  </span>
                  <p style={{...style.messageText, textAlign: msg.sender === "user" ? "right" : "left"}}>{msg.text}</p>
                </div>
              </div>
            ))
          )}
          {isLoading && (
            <div style={style.aiMessage}>
              <div style={style.loadingIndicator}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
        </div>

        <div style={style.inputArea}>
          <div style={style.inputWrapper}>
            <input
              type="text"
              style={style.textInput}
              placeholder="Pergunte algo para a IA..."
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSend()}
              disabled={isLoading}
            />
            <button
              style={
                isLoading
                  ? { ...style.sendButton, ...style.disabledButton }
                  : style.sendButton
              }
              onClick={() => handleSend()}
              disabled={isLoading}
            >
              <FiSend size={20} />
            </button>
          </div>
          <p style={style.disclaimer}>
            A IA Interna pode cometer erros. Considere verificar informações
            importantes.
          </p>
        </div>
      </div>
    </div>
  );
}
